/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";
import { CardBase } from "ui/CardBase";
import { convertBrToLineBreakCode } from "utility/convertBrTo";

import {
  amountStyle,
  footerStyle,
  labelWrapperStyle,
  shopNameStyle,
  taxStyle,
  titleStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { FcWithoutChildren } from "../../types/fcWithoutChildren";
import type { Props } from "./props";

export const GoodsCard: FcWithoutChildren<Props> = (props) => {
  const { imagePath, labelComponent, shopName, title } = props;

  const { formattedAmount, sanitizedTitle, tax } = useThis(props);

  return (
    <CardBase
      imageElement={
        imagePath === null ? null : <img src={imagePath} alt={sanitizedTitle} />
      }
    >
      <h3 css={titleStyle}>{title}</h3>

      <p css={shopNameStyle}>{convertBrToLineBreakCode(shopName)}</p>

      <footer css={footerStyle}>
        <span css={amountStyle}>
          ¥{formattedAmount}
          <span css={taxStyle}>{tax}</span>
        </span>
        {labelComponent ? (
          <span css={labelWrapperStyle}>{labelComponent}</span>
        ) : null}
      </footer>
    </CardBase>
  );
};
